import { render, staticRenderFns } from "./WidgetBody.vue?vue&type=template&id=4ab8dbc2&"
import script from "./WidgetBody.vue?vue&type=script&lang=ts&"
export * from "./WidgetBody.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports